<template>
    <div class="CreateData spackage padding-20 bgc box-shadow">
        <!-- start 顶部菜单栏 -->

        <section>
            <header>
                <h1 class="name">基本信息</h1>
            </header>

            <el-form :model="form" :rules="rules">
                <el-form-item label="增加资料" prop="logodata" required>
                    <div class="upload-pdf">
                        <uploadFile v-if="form.logodata.length < 3" :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></uploadFile>
                        <el-button type="info" v-else>上传附件...</el-button>
                        <span style="margin-left: 20px">还可以上传 {{ 3 - form.logodata.length }} 份资料</span>
                    </div>
                    <div class="pdfMsg" v-if="form.logodata">
                        <div class="item" v-for="(logodata,index) in form.logodata">
                            <span class="fname">{{logodata.fname}}</span><span>{{fsize(logodata.fsize)}}</span><span class="delPdf" @click="delPdf(index)">删除</span>
                        </div>
                    </div>
                    <!--
                    item.pdfinfo.furl
                    item.pdfinfo.fname
                    item.pdfinfo.fsize
                    -->

                </el-form-item>
                <el-form-item label="内容详情">
                    <div class="ueditorBox">
                        <uEditor :content="form.content" ref="uEditor" @getUEditorContent="getMsgContent"></uEditor>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button style="margin-left: 66px" @click="back">取消</el-button>
                    <el-button type="primary" @click="add">保存</el-button>
                </el-form-item>
            </el-form>

        </section>
    </div>
</template>

<script>
    import {saveCwKmcStarfileinfo} from '@/api/communityApi'
    import UEditor from 'base/uEditor/uEditor'
    import UploadFile from 'base/upload/uploadFile'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {computeFileSize, formatFileInfo} from 'common/js/tools'
    import {mapGetters,mapActions} from 'vuex'
    export default {
        name: "CreateData",
        data() {
            let validatePdfInfo = (rule, value, callback) => {
                if (!this.form.logodata) {
                    callback(new Error('请上传PDF文件'))
                } else {
                    callback()
                }
            }
            return {
                uploadVideoType: {
                    catecode: '94',
                    datatype: 'FILE'
                },
                form: {
                    starid: this.$route.query.innerid,
                    logodata: [],
                    content: '',
                    atttype: 2
                },
                fileRule: {
                    btnName: '上传附件...',
                    cls: '',
                    accept: 'application/pdf',
                    size: 10,
                    width: '',
                    height: ''
                },
                rules: {
                    logodata : [
                        {validator: validatePdfInfo, trigger: 'blur'}
                    ],
                    content: [

                    ]
                }
            }
        },
        mounted() {
            // 信息取得
            // this.$refs.uEditor.init(this.articleData.despfee)

        },
        methods: {
            // 内容详情
            getMsgContent(content) {
                this.form.content = content
            },
            setFile(file) {
                computeFileSize()
                delete file.type
                // console.log('file',file)
                this.form.logodata.push(file)
                    // = file
            },
            delPdf(index) {
                let len = this.form.logodata.length,
                    logolist = this.form.logodata

                for (let i = 0; i < len; i++ ) {
                    if ( i === index ) {
                        this.$nextTick(() => {
                            logolist.splice(i,1)
                        })
                    }
                }
                // this.form.logodata = {
                //     bucket: '',
                //     fname: '',
                //     fsize: '',
                //     key: '',
                //     mimeType: '',
                //     furl: ''
                // }
            },
            back() {
                this.$router.go(-1)
            },
            add() {
                let data = JSON.parse(JSON.stringify(this.form))

                if (data.logodata.length < 1) {
                    this.$message.error('上传附件不能为空')
                } else {

                    data.logodata = JSON.stringify(data.logodata)

                    this.setLoading(true)
                    saveCwKmcStarfileinfo({
                        data: data,
                        success: data => {
                            this.$message.success('保存成功')
                            this.setLoading(false)
                            this.back()
                        },
                        error: data => {
                            this.$message.error(data.msg)
                            this.setLoading(false)
                        }
                    })
                }
            },
            ...mapActions([
                'setLoading'
            ]),
        },
        computed: {
            fsize () {
                return function(size) {
                    return computeFileSize(size)
                }
            },
        },
        components: {
            Loading,
            UEditor,
            UploadFile
        },
    }
</script>

<style lang="scss" type="text/scss">
    @import "~common/scss/variable";
    @import "~common/scss/mixin";
    .CreateData {
        .name {
            margin-bottom: 20px;
            padding-left: 8px;
            font-size: 16px;
            font-weight: bold;
            border-left: solid 2px #00a0e9;
        }

        .pdfMsg{
            margin-top: 20px;
            margin-left: 86px;
            width: 400px;
            line-height: 40px;
            box-sizing: border-box;
            overflow: hidden;
            margin-bottom: 10px;

            .item {
                display: block;
                margin-bottom: 10px;
                padding: 0 20px;
                width: 100%;
                overflow: hidden;
                box-sizing: border-box;
                border: solid 1px #DCDFE6;
                background: #F5F7FA;
                span {
                    float: left;
                    padding-right: 10px;
                }
                 .delPdf{
                    float: right !important;
                    color: #409EFF;
                    cursor: pointer;
                }
                .fname{
                    width: 230px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    display: inline-block;
                }
            }
           
        }
        .upload-pdf{
            @include flexBox(flex-start);
        }
    }
</style>
